import { render, staticRenderFns } from "./NixiaMessageBubble.vue?vue&type=template&id=56da81e2&scoped=true&"
import script from "./NixiaMessageBubble.vue?vue&type=script&lang=js&"
export * from "./NixiaMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./NixiaMessageBubble.vue?vue&type=style&index=0&id=56da81e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da81e2",
  null
  
)

export default component.exports